export enum DocumentStatus {
  Draft = 0,
  ForApproval = 2,
  Published = 3,
  Expired = 5,
  Expiring = 6,
  Rejected = 7,
  UnderRevision = 8,
  ChangeRequestInitiated = 9,
  Deleted = 30,
  Disabled = 31,
  ChangeRequest = 32,
}

export const DOCUMENT_STATUS_LABELS: any = {
  [DocumentStatus.Draft]: 'draft',
  [DocumentStatus.ForApproval]: 'forApproval',
  [DocumentStatus.Published]: 'published',
  [DocumentStatus.Expired]: 'expired',
  [DocumentStatus.Expiring]: 'expiring',
  [DocumentStatus.Rejected]: 'rejected',
  [DocumentStatus.UnderRevision]: 'underRevision',
  [DocumentStatus.Deleted]: 'deleted',
  [DocumentStatus.Disabled]: 'disabled',
  [DocumentStatus.ChangeRequest]: 'changeRequests',
};

export const DOCUMENT_STATUS_DISPLAY_LABELS: any = {
  [DocumentStatus.Draft]: 'draft',
  [DocumentStatus.ForApproval]: 'forApproval',
  [DocumentStatus.Published]: 'published',
  [DocumentStatus.Expired]: 'expired',
  [DocumentStatus.Expiring]: 'expiring',
  [DocumentStatus.Rejected]: 'rejected',
  [DocumentStatus.UnderRevision]: 'underRevision',
  [DocumentStatus.ChangeRequestInitiated]: 'changeRequestInitiated',
  [DocumentStatus.Deleted]: 'deleted',
  [DocumentStatus.Disabled]: 'disabled',
  [DocumentStatus.ChangeRequest]: 'changeRequests',
};
